import React from "react";
import { Link } from "react-router-dom";
import { FaHome, FaArrowLeft, FaHeadset, FaSearch, FaExclamationTriangle } from "react-icons/fa";

export default function NotFound404() {
  return (
    <>
      <div className="flex flex-col justify-center items-center min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-950 px-6 relative overflow-hidden">
        {/* Arka plan dekorasyonu - Dark tema */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-32 w-80 h-80 bg-gradient-to-r from-blue-500/10 to-indigo-600/10 rounded-full blur-3xl opacity-60"></div>
          <div className="absolute -bottom-40 -left-32 w-80 h-80 bg-gradient-to-r from-purple-500/10 to-pink-600/10 rounded-full blur-3xl opacity-60"></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-gray-800/20 to-blue-600/10 rounded-full blur-3xl opacity-30"></div>
          {/* Grid pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0" style={{
              backgroundImage: `linear-gradient(to right, #4B5563 1px, transparent 1px),
                                linear-gradient(to bottom, #4B5563 1px, transparent 1px)`,
              backgroundSize: '50px 50px'
            }}></div>
          </div>
        </div>

        <div className="text-center max-w-lg w-full relative z-10">
          {/* Animasyonlu 404 */}
          <div className="relative mb-8">
            <div className="relative inline-block">
              <h1 className="text-8xl sm:text-9xl font-black tracking-tighter text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text mb-4 leading-none">
                404
              </h1>
              <div className="absolute -top-4 -right-4 w-6 h-6 bg-gradient-to-r from-red-500 to-pink-500 rounded-full animate-pulse shadow-lg shadow-red-500/50"></div>
              <div className="absolute -bottom-2 -left-4 w-4 h-4 bg-gradient-to-r from-amber-500 to-yellow-500 rounded-full animate-bounce shadow-lg shadow-amber-500/50"></div>
              <div className="absolute -inset-8 bg-gradient-to-r from-blue-500/10 via-transparent to-purple-500/10 blur-2xl opacity-30"></div>
            </div>
            <div className="mt-6 flex items-center justify-center gap-3">
              <p className="text-gray-400 font-medium">Sayfa Bulunamadı</p>
            </div>
          </div>



          {/* Başlık ve Açıklama */}
          <h2 className="text-2xl font-bold text-white mb-4">
            Oops! Kayıp Gibisiniz
          </h2>
          <p className="text-gray-400 mb-8 leading-relaxed text-lg">
            Aradığınız sayfa taşınmış, silinmiş veya adı değiştirilmiş olabilir. 
            Aşağıdaki seçeneklerle gezinmeye devam edebilirsiniz.
          </p>



          {/* Butonlar */}
          <div className="space-y-4 mb-8">
            <Link
              to="/"
              className="group relative flex items-center justify-center w-full bg-gradient-to-r from-blue-500 to-gray-600 hover:from-blue-600 hover:to-gray-700 text-white font-semibold px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl border border-blue-500/30"
            >
              <FaHome className="mr-3 transform group-hover:scale-110 transition-transform" />
              <span>Ana Sayfaya Dön</span>
              <div className="absolute right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform group-hover:translate-x-1">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </div>
            </Link>
            
            <Link
              to="/gitarlar"
              className="group relative flex items-center justify-center w-full bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-700 hover:to-gray-800 text-white font-semibold px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105 border border-gray-700/50 shadow-lg hover:shadow-xl"
            >
              <FaSearch className="mr-3 transform group-hover:scale-110 transition-transform" />
              <span>Gitarları Keşfet</span>
              <div className="absolute right-6 opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform group-hover:translate-x-1">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                </svg>
              </div>
            </Link>
            
            <button
              onClick={() => window.history.back()}
              className="group relative flex items-center justify-center w-full border-2 border-gray-700 text-gray-300 hover:bg-gray-800 hover:text-white hover:border-gray-600 font-semibold px-8 py-4 rounded-xl transition-all duration-300 transform hover:scale-105"
            >
              <FaArrowLeft className="mr-3 transform group-hover:-translate-x-1 transition-transform" />
              <span>Geri Dön</span>
            </button>
          </div>

          {/* Ekstra yardım */}
          <div className="p-5 bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-xl border border-gray-700/50 group hover:border-blue-500/30 transition-all duration-300">
            <div className="flex items-center justify-center gap-3 mb-2">
              <div className="p-2 bg-gradient-to-r from-blue-500/20 to-blue-600/10 rounded-lg">
                <FaHeadset className="text-blue-400" />
              </div>
              <h3 className="text-white font-medium">Yardıma mı ihtiyacınız var?</h3>
            </div>
            <p className="text-sm text-gray-400 mb-3">
              İletişime geçerek destek alabilirsiniz.
            </p>
            <Link 
              to="/iletisim" 
              className="inline-flex items-center gap-2 text-blue-400 hover:text-blue-300 font-medium text-sm transition-colors"
            >
              <span>İletişim Sayfası</span>
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
          </div>
        </div>

        {/* Alt kısım animasyon */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
          <div className="flex space-x-3">
            {[...Array(5)].map((_, i) => (
              <div 
                key={i} 
                className="w-2 h-2 bg-gradient-to-r from-blue-400/50 to-purple-400/50 rounded-full animate-pulse"
                style={{ 
                  animationDelay: `${i * 0.1}s`,
                  animationDuration: '1.5s'
                }}
              ></div>
            ))}
          </div>
        </div>

        {/* Kenar dekorasyonları */}
        <div className="absolute top-10 left-10 hidden md:block">
          <div className="w-32 h-32 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-full blur-xl"></div>
        </div>
        <div className="absolute bottom-10 right-10 hidden md:block">
          <div className="w-40 h-40 bg-gradient-to-r from-purple-500/5 to-pink-500/5 rounded-full blur-xl"></div>
        </div>

        {/* Floating notes */}
        <div className="absolute top-1/4 right-10 animate-float">
          <div className="w-4 h-4 bg-blue-400/20 rounded-full"></div>
        </div>
        <div className="absolute bottom-1/3 left-10 animate-float" style={{ animationDelay: '0.5s' }}>
          <div className="w-3 h-3 bg-purple-400/20 rounded-full"></div>
        </div>
      </div>

      {/* Animasyon tanımları */}
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(180deg);
          }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
    </>
  );
}